import { render, staticRenderFns } from "./SubscriptionType.vue?vue&type=template&id=2a0e1caf"
import script from "./SubscriptionType.vue?vue&type=script&lang=js"
export * from "./SubscriptionType.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionType.vue?vue&type=style&index=0&id=2a0e1caf&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports